import { withCtxSlice } from './with-ctx-slice'
import { breakpointsCtx } from './breakpoints-ctx'

const withBreakpointsSlice = withCtxSlice(breakpointsCtx)

export { withBreakpointsSlice }
